export default "__VITE_ASSET__CEdk8Xw1__"